<template>
	<div class="case">
		<h1 class="title border_b">康复案例</h1>
		<div class="clear_both between_box">
			<div class="l">
				<div class="which">
					<div class="which_en bg_theme">KEFEI SHIJUE</div>
					<div class="whick_kf text_theme">科<span style="display: inline-block;width: 20px;vertival-align: top;"></span>飞<span style="display: inline-block;width: 20px;vertival-align: top;"></span>视<span style="display: inline-block;width: 20px;vertival-align: top;"></span>觉</div>
					<h1 class="which_big text_theme">典型案例</h1>
					<h1 class="which_num text_theme">CASE{{ num }}</h1>
				</div>
				<h3 class="tit" style="margin-top: 4px;">{{ data.title || '' }}案例</h3>
				<!-- <h3 class="tit">案例</h3> -->
			</div>
			<div class="r" v-html="data.content || ''">
				<!-- <img src="data" alt=""> -->
				<!-- <div class="r_t">
					<h1 class="tt">6岁时发现弱视，如今22岁的我终于拥抱光明</h1>
					<h3 class="disease text_one">22岁，远视型弱视，伴随眼球震颤</h3>
					<img src="../../../../assets/1982.png" alt="">
					<p class="hope">有很多和我一样，甚至比我大很多的人，都在继续接受治疗，这让我有了希望——</p>
				</div>
				<div class="r_step">
					<h3 class="step_tt text_one">1.<span style="display: inline-block;width: 40px;vertival-align: top;"></span>6岁时发现弱视</h3>
					<div class="step_content">
						<p>我是在2003年六岁的时候发现弱视的。</p>
						<br/>
						<p>那时候我妈妈发现我看电视喜欢在电视前面看，就带着我去医院检查，发现了双眼弱视，然后接受了治疗，那时候科技不发达，只有简单的穿针和红闪治疗，治疗了大约一年左右。</p>
						<br/>
						<p>因为没有太多的精力和对弱视的危害性缺乏就没再继续治疗了，后期一直佩戴眼镜。</p>
						<br/>
						<p>一直到高中，因为我的眼镜度数太高，镜片特别厚，觉得太难看的，就把眼镜下了，没戴眼镜大约有五六年的时间，期间一直没有戴过眼镜，有明显觉得眼睛视力下降了，看手机越来做不清楚，看东西喜欢眯着眼睛看。</p>
					</div>
				</div>
				<div class="r_step">
					<h3 class="step_tt text_one">2.<span style="display: inline-block;width: 40px;vertival-align: top;"></span>朋友提醒我去检查</h3>
					<div class="step_content">
						<p>在2018年八月份的时候，有个朋友家的小孩也发现了弱视。</p>
						<br/>
						<p>后来我们聊天的时候他和我说你这么久不戴眼镜也要去医院看一下有没有眼底病变，如果有眼底病变会比较麻烦。</p>
						<br/>
						<p>当时也是被吓到了，没几天就去医院检查了，眼底没有问题，当时检查的视力是矫正后0.4 0.5 当时医生建议我佩戴眼镜。</p>
						<br/>
						<p>我了解了一下眼镜，就回家了。</p>
					</div>
				</div>
				<div class="r_step">
					<h3 class="step_tt text_one">3.<span style="display: inline-block;width: 40px;vertival-align: top;"></span>听说有成人提升到了1.0</h3>
					<div class="step_content">
						<p>后来在网上搜索关于很多弱视的问题，就在弱视吧里看到了别人讲述了自己的弱视治疗过程和结果，从0.6恢复到现在的1.0当时觉得很震撼，就加了他的微信，问了他很多问题。</p>
						<br/>
						<p>他把我拉到了一个弱视的群里，群里的人全部都是大龄弱视，在此之前我有查过很多的资料，都是说12岁以后弱视就没有治疗希望了。</p>
						<br/>
						<p>在这个群里却有很多和我一样甚至比我大很多的人都在继续接受治疗，这让我有了希望。</p>
						<br/>
						<p>就按照他的要求去医院检查了一系列的项目，当时给我检查的医生也建议我可以继续治疗，于是从新配了框架眼镜和RGP，九月份开始了治疗。</p>
						<br/>
						<p>从穿针到软件训练，大概训练了有一两个月，中间有去过两次医院RGP复查，视力基本上都是在0.4这样。</p>
					</div>
				</div>
				<div class="r_step">
					<h3 class="step_tt text_one">4.<span style="display: inline-block;width: 40px;vertival-align: top;"></span>参加科飞视觉训练</h3>
					<div class="step_content">
						<p>当时我所在的弱视群里的崔老师说科飞在招募视功能训练人员，当时便按照要求报名了，加入科飞后便开始了为期三个月的训练。</p>
						<br/>
						<p>训练前崔老师和我沟通过， 因为我是高度弱视，并且双眼震颤，她告诉我我恢复起来可能会比其他人要慢，而且伴有视疲劳。</p>
						<br/>
						<p>训练了大约十几天以后，眼睛就出现在很多视疲劳的症状，眼睛疼痛，连带着脑袋和太阳穴都不能碰，一碰就痛，依旧坚持训练，后期慢慢的减少眼睛疼痛的症状。</p>
						<br/>
						<p>在训练了大约两个月的时候，崔老师让我们训练的人员去医院检查一下视力，看一下是否有提升，当时没抱什么太大的希望去的医院。</p>
					</div>
				</div>
				<div class="r_step">
					<h3 class="step_tt text_one">5.<span style="display: inline-block;width: 40px;vertival-align: top;"></span>视力提升了</h3>
					<div class="step_content">
						<p>因为当时并没有感觉有视力上的提升，当时挂号戴着RGP在自然光下灯箱检查了一下视力0.3 0.4并没有提升，心里有点难过，下掉RGP然后又去综合验光，拿到检查单，0.8- 和0.8。</p>
						<br/>
						<p>当时那个激动……</p>
						<br/>
						<p>拿去给医生看，医生告诉我，综合验光是在比较暗的房间里看的会比较仔细，之前我也做过综合验光都是0.4、0.5，随后医生检查了一下我的眼睛，说上次来眼球有震颤，颤，现在好多了，让我继续训练。</p>
						<br/>
						<p>继而鼓励大家坚信训练就有收获，我也会继续保持训练的。</p>
					</div>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			num: {
				type: String,
				default: ''
			},
			data: {
				type: Object,
				default() { return {}; }
			}
		},
		data() {
			return{
				
			}
		}
	}
</script>

<style scoped>
	.case{ padding: 10px 0 100px 0; }
	.case .title{ position: relative;font-size: 24px;font-weight: bold;line-height: 56px; }
	.case .between_box{ margin: 26px 0 0 0; }
	.case .between_box .l{ float: left;width: 217px; }
	.case .which{ height: 230px;padding: 24px 0 0 30px;background-image: url(../../../../assets/case_bg.png);background-size: 100% 100%; }
	.case .which_en{ width: 113px;padding: 0 4px;font-size: 10px;color: #fff;line-height: 22px; }
	.case .whick_kf{ font-size: 12px;line-height: 22px; }
	.case .which_big{ margin-top: 4px;font-size: 42px;line-height: 54px; }
	.case .which_num{ font-size: 46px;line-height: 48px; }
	.case .between_box .l .tit{ font-size: 30px;color: #5b6a75;line-height: 38px; }
	.case .between_box .r{ float: right;width: 700px; }
	.case .between_box .r img{ display: block;width: 100%; }
	.case .r_t{ width: 483px;margin: 0 auto 10px; }
	.case .r_t .tt{ font-size: 18px;font-weight: bold;line-height: 32px; }
	.case .r_t .disease{ height: 30px;margin-top: 45px;padding: 0 204px 0 40px;background-image: url(../../../../assets/rect_1.png);background-size: 100% 100%;color: #fff;line-height: 30px; }
	.case .r_t img{ display: block;width: 100%;margin-top: 4px; }
	.case .r_t .hope{ margin-top: 32px;font-size: 16px;font-weight: bold;line-height: 22px; }
	.case .r_step{ margin-top: 20px; }
	.case .step_tt{ position: relative;padding: 0 0 7px 35px;font-size: 16px;font-weight: bold;line-height: 26px; }
	.case .step_tt::after{ content: "";display: block;position: absolute;width: 100%;height: 7px;bottom: 0;left: 0;background-image: url(../../../../assets/rect_2.png);background-size: 100% 100%; }
	.case .step_content{ padding: 16px 20px 0;color: #6b8189;line-height: 20px; }
</style>
